import { formatUsd } from "../../shared/money";

interface PressButtonProps {
  minimumPriceCents: number;
  disabled: boolean;
  loading: boolean;
  onPress: () => void;
}

export function PressButton({ minimumPriceCents, disabled, loading, onPress }: PressButtonProps) {
  return (
    <div className="button-machine" aria-live="polite">
      <div className="machine-label">
        <span>NEXT PRESS MINIMUM</span>
        <strong>{formatUsd(minimumPriceCents)}</strong>
      </div>
      <div className="button-guard">
        <button
          className="press-button"
          type="button"
          disabled={disabled || loading}
          aria-label={`Don't press. The current minimum is ${formatUsd(minimumPriceCents)}.`}
          onClick={() => {
            if (navigator.vibrate) navigator.vibrate(18);
            onPress();
          }}
        >
          <span>{loading ? "HOLD ON" : "DON'T PRESS"}</span>
          <span>{loading ? "" : `FROM ${formatUsd(minimumPriceCents)}`}</span>
        </button>
      </div>
      <p className="button-note">
        Choose {formatUsd(minimumPriceCents)} or any higher whole-dollar amount.
      </p>
    </div>
  );
}
